import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPUTWithBody
} from '../api';
import newFetch from '../utils/newFetch';
import download from 'downloadjs';
const state = {
  couriers: [],
  shipments: [],
  manegementShipments: [],
  directDeliverers: [],
  transhipments: [],
  stops: [],
  paymentOrders: [],
  paymentOrderDetail: null,
  summaryTypes: [],
  summaryStatus: [],
  directDeliverersPaymentOrder: [],
  transhipmentsPaymentOrder: [],
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  paginateDirectDeliverers: {
    pageNumber: 1,
    pageSize: 10000,
    totalRecords: 0,
    totalPages: 0
  },
  paginateTranshipment: {
    pageNumber: 1,
    pageSize: 10000,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    CreatedAt: null,
    DirectDelivererName: null,
    StatusId: null,
    ResponsibleUserName: null
  },
  filterDirectDeliverers: {
    DirectDelivererId: null,
    CteNumber: null,
    CreatedAtStart: null,
    CreatedAtEnd: null
  },
  filterTranshipment: {
    TranshipmentId: null,
    CteNumber: null,
    CreatedAtStart: null,
    CreatedAtEnd: null
  },
  filterPaymentOrders: {
    DelivererId: null,
    CreatedAtStart: null,
    CreatedAtEnd: null,
    PaymentForecastStart: null,
    PaymentForecastEnd: null,
    PaymentStart: null,
    PaymentEnd: null,
    TypeId: null,
    StatusId: null
  }
};

const getters = {
  getCouriers: (state) => state.couriers,
  getShipments: (state) => state.shipments,
  getManegementShipments: (state) => state.manegementShipments,
  getDirectDeliverers: (state) => state.directDeliverers,
  getAllTranshipments: (state) => state.transhipments,
  getStops: (state) => state.stops,
  getPaymentOrders: (state) => state.paymentOrders,
  getPaymentOrderDetail: (state) => state.paymentOrderDetail,
  getSummaryTypes: (state) => state.summaryTypes,
  getSummaryStatus: (state) => state.summaryStatus,
  getDirectDeliverersPaymentOrder: (state) => state.directDeliverersPaymentOrder,
  getTranshipmentsPaymentOrder: (state) => state.transhipmentsPaymentOrder,
  getFilters: ({ paginate, filterPaymentOrders }) => {
    return (
      `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filterPaymentOrders.DelivererId ? '&DelivererId=' + filterPaymentOrders.DelivererId : '') +
      (filterPaymentOrders.CreatedAtStart ? '&CreatedAtStart=' + filterPaymentOrders.CreatedAtStart : '') +
      (filterPaymentOrders.CreatedAtEnd ? '&CreatedAtEnd=' + filterPaymentOrders.CreatedAtEnd : '') +
      (filterPaymentOrders.PaymentForecastStart
        ? '&PaymentForecastStart=' + filterPaymentOrders.PaymentForecastStart
        : '') +
      (filterPaymentOrders.PaymentForecastEnd ? '&PaymentForecastEnd=' + filterPaymentOrders.PaymentForecastEnd : '') +
      (filterPaymentOrders.PaymentStart ? '&PaymentStart=' + filterPaymentOrders.PaymentStart : '') +
      (filterPaymentOrders.PaymentEnd ? '&PaymentEnd=' + filterPaymentOrders.PaymentEnd : '') +
      (filterPaymentOrders.TypeId ? '&TypeId=' + filterPaymentOrders.TypeId : '') +
      (filterPaymentOrders.StatusId ? '&StatusId=' + filterPaymentOrders.StatusId : '')
    );
  },
  getDirectDeliverersFilters: ({ paginateDirectDeliverers, filterDirectDeliverers }) => {
    return (
      `?PageSize=${paginateDirectDeliverers.pageSize}&PageNumber=${paginateDirectDeliverers.pageNumber}` +
      (filterDirectDeliverers.DirectDelivererId
        ? '&DirectDelivererId=' + filterDirectDeliverers.DirectDelivererId
        : '') +
      (filterDirectDeliverers.CteNumber ? '&CteNumber=' + filterDirectDeliverers.CteNumber : '') +
      (filterDirectDeliverers.CreatedAtStart ? '&CreatedAtStart=' + filterDirectDeliverers.CreatedAtStart : '') +
      (filterDirectDeliverers.CreatedAtEnd ? '&CreatedAtEnd=' + filterDirectDeliverers.CreatedAtEnd : '')
    );
  },
  getTranshipmentFilters: ({ paginateTranshipment, filterTranshipment }) => {
    return (
      `?PageSize=${paginateTranshipment.pageSize}&PageNumber=${paginateTranshipment.pageNumber}` +
      (filterTranshipment.TranshipmentId ? '&TranshipmentId=' + filterTranshipment.TranshipmentId : '') +
      (filterTranshipment.CteNumber ? '&CteNumber=' + filterTranshipment.CteNumber : '') +
      (filterTranshipment.CreatedAtStart ? '&CreatedAtStart=' + filterTranshipment.CreatedAtStart : '') +
      (filterTranshipment.CreatedAtEnd ? '&CreatedAtEnd=' + filterTranshipment.CreatedAtEnd : '')
    );
  }
};

const mutations = {
  setShipments(state, payload) {
    state.shipments = payload;
  },
  setManegementShipments(state, payload) {
    state.manegementShipments = payload;
  },
  setDirectDeliverers(state, payload) {
    state.directDeliverers = payload;
  },
  setTranshipments(state, payload) {
    state.transhipments = payload;
  },
  setStops(state, payload) {
    state.stops = payload;
  },
  setSummaryTypes(state, payload) {
    state.summaryTypes = payload;
  },
  setSummaryStatus(state, payload) {
    state.summaryStatus = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterCreatedAt(state, payload) {
    state.filters.CreatedAt = payload;
  },
  setFilterDirectDelivererName(state, payload) {
    state.filters.DirectDelivererName = payload;
  },
  setFilterStatusId(state, payload) {
    state.filters.StatusId = payload;
  },
  setFilterResponsibleUserName(state, payload) {
    state.filters.ResponsibleUserName = payload;
  },
  setPaymentOrders(state, payload) {
    state.paymentOrders = payload;
  },
  setPaymentOrderDetails(state, payload) {
    state.paymentOrderDetail = payload;
  },
  setDirectDeliverersPaymentOrder(state, payload) {
    state.directDeliverersPaymentOrder = payload;
  },
  setTranshipmentsPaymentOrder(state, payload) {
    state.transhipmentsPaymentOrder = payload;
  },
  setFiltersDirectDelivererDirectDelivererId(state, payload) {
    state.filterDirectDeliverers.DirectDelivererId = payload;
  },
  setFiltersDirectDelivererCteNumber(state, payload) {
    state.filterDirectDeliverers.CteNumber = payload;
  },
  setFiltersDirectDelivererCreatedAtStart(state, payload) {
    state.filterDirectDeliverers.CreatedAtStart = payload;
  },
  setFiltersDirectDelivererCreatedAtEnd(state, payload) {
    state.filterDirectDeliverers.CreatedAtEnd = payload;
  },
  setFiltersTranshipmentTranshipmentId(state, payload) {
    state.filterTranshipment.TranshipmentId = payload;
  },
  setFiltersTranshipmentCteNumber(state, payload) {
    state.filterTranshipment.CteNumber = payload;
  },
  setFiltersTranshipmentCreatedAtStart(state, payload) {
    state.filterTranshipment.CreatedAtStart = payload;
  },
  setFiltersTranshipmentCreatedAtEnd(state, payload) {
    state.filterTranshipment.CreatedAtEnd = payload;
  },
  setFiltersPaymentOrderDelivererId(state, payload) {
    state.filterPaymentOrders.DelivererId = payload;
  },
  setFiltersPaymentOrderCreatedAtStart(state, payload) {
    state.filterPaymentOrders.CreatedAtStart = payload;
  },
  setFiltersPaymentOrderCreatedAtEnd(state, payload) {
    state.filterPaymentOrders.CreatedAtEnd = payload;
  },
  setFiltersPaymentOrderPaymentForecastStart(state, payload) {
    state.filterPaymentOrders.PaymentForecastStart = payload;
  },
  setFiltersPaymentOrderPaymentForecastEnd(state, payload) {
    state.filterPaymentOrders.PaymentForecastEnd = payload;
  },
  setFiltersPaymentOrderPaymentStart(state, payload) {
    state.filterPaymentOrders.PaymentStart = payload;
  },
  setFiltersPaymentOrderPaymentEnd(state, payload) {
    state.filterPaymentOrders.PaymentEnd = payload;
  },
  setFiltersPaymentOrderTypeId(state, payload) {
    state.filterPaymentOrders.TypeId = payload;
  },
  setFiltersPaymentOrderStatusId(state, payload) {
    state.filterPaymentOrders.StatusId = payload;
  }
};

const actions = {
  fetchDirectDeliverers(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getDirectDelivererWithoutPaymentOrder + context.getters.getDirectDeliverersFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setDirectDeliverers', data);

          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchShipmentsByDirectDelivererId(context, directDelivererId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getShipmentsByDirectDeliverer +
          context.getters.getDirectDeliverersFilters +
          '&directDelivererId=' +
          directDelivererId,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setShipments', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchTranshipment(context, params = { pageSize: 10, pageNumber: 1 }) {
    const { pageSize, pageNumber, date, date1, transhipmentId, CTENumber } = params;
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getTranshipmentsWithoutPaymentOrder +
          `?PageNumber=${pageNumber ? pageNumber : 1}&PageSize=${pageSize}` +
          (date ? `&CreatedAtStart=${date}` : '') +
          (date1 ? `&CreatedAtEnd=${date1}` : '') +
          (transhipmentId ? `&TranshipmentId=${transhipmentId}` : '') +
          (CTENumber ? `&CteNumber=${CTENumber}` : ''),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setTranshipments', data);

          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchStopsByTranshipmentId(context, cargoId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStopsWithoutPaymentOrder + context.getters.getTranshipmentFilters + '&cargoId=' + cargoId,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setStops', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchCargosByTranshipmentId(context, transhipmentId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getCargosWithoutPaymentOrders +
          context.getters.getTranshipmentFilters +
          '&transhipmentId=' +
          transhipmentId,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setStops', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchPaymentOrders(_, params) {
    const {
      pageNumber,
      pageSize,
      initialCreatedAt,
      endCreatedAt,
      initialForecast,
      endForecast,
      initialPayment,
      endPayment,
      statusId,
      typeId,
      transhipmentOrDelivererId,
      isDischarge,
      boardingNumbers
    } = params;

    let boardingNumbersParam = boardingNumbers.length
      ? boardingNumbers.reduce((acc, cur, i) => {
          const concatSign = boardingNumbers.length - 1 === i ? '' : '&';
          return (acc += `BoardingNumber=${cur}${concatSign}`);
        }, '')
      : [];

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getAllPaymentOrders +
          `?PageNumber=${pageNumber}&PageSize=${pageSize}` +
          (initialCreatedAt ? `&CreatedAtStart=${initialCreatedAt}` : '') +
          (endCreatedAt ? `&CreatedAtEnd=${endCreatedAt}` : '') +
          (initialForecast ? `&PaymentForecastStart=${initialForecast}` : '') +
          (endForecast ? `&PaymentForecastEnd=${endForecast}` : '') +
          (initialPayment ? `&PaymentStart=${initialPayment}` : '') +
          (endPayment ? `&PaymentEnd=${endPayment}` : '') +
          (statusId ? `&StatusId=${statusId}` : '') +
          (typeId ? `&TypeId=${typeId.id}` : '') +
          (transhipmentOrDelivererId !== null ? `&DelivererId=${transhipmentOrDelivererId}` : '') +
          (boardingNumbers.length ? `&${boardingNumbersParam}` : '') +
          (isDischarge !== null ? `&IsDischarge=${isDischarge}` : ''),

        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchShipment(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getShipment + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setShipments', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipments(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipments + context.getters.getManegementFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          context.commit('setManegementShipments', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsCargoByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getManegementShipmentsCargos + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsStopsByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getManegementShipmentsStops + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsDeliveriesByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getManegementShipmentsDeliveries + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManegementShipmentsNFEByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getManegementShipmentsNFE + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchShipmentByID(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getShipment + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createPaymentOrder(context, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createPaymentOrder, requestOptionsPOST(localStorage.getItem('accessToken'), { ...body }))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  payPaymentOrder(context, body) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.payPaymentOrder, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  undoPaymentOrder(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.undoPaymentOrder + '?paymentOrderId=' + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getPaymentOrderDetails(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getPaymentOrderDetails + '?paymentOrderId=' + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          context.commit('setPaymentOrderDetails', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getSummaryTypePaymentOrder(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSummaryTypePaymentOrder, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setSummaryTypes', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getSummaryStatusPaymentOrder(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSummaryStatusPaymentOrder, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setSummaryStatus', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getDirectDeliverersForPaymentOrder(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDirectDeliverersForPaymentOrder, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setDirectDeliverersPaymentOrder', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getTranshipmentForPaymentOrder(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getTranshipmentForPaymentOrder, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setTranshipmentsPaymentOrder', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getStopsWithoutPaymentOrderByTranshipmentId(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStopsWithoutPaymentOrderByTranshipmentId + '?transhipmentId=' + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getPaymentOrderPDF(context, idOrderPayment) {
    const base_url = baseURL + Api.getPDFPaymentOrder + '?idOrderPayment=' + idOrderPayment;
    const obj = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken').toString(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Response-Type': 'APPLICATION/octet-stream'
      },
      method: 'GET'
    };

    return new Promise((resolve, reject) => {
      fetch(base_url, obj)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return reject(response);
          }
        })
        .then((obj) => {
          download(atob(obj.file.fileContents), obj.nameFile);
          resolve(obj);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  },
  getAllAditionals(_, params = { pageNumber: 1, pageSize: 10 }) {
    const {
      pageNumber,
      pageSize,
      initialDate,
      endDate,
      isDiscount,
      isDirectDeliverer,
      stopId,
      boardingId,
      applicationUserId,
      linkedPaymentOrder,
      nfeNumber,
      senderId,
      isLink
    } = params;

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL +
          Api.getAllAditionals +
          `?PageNumber=${pageNumber}&PageSize=${pageSize}` +
          (initialDate ? `&AdditionalDateStart=${initialDate}` : '') +
          (endDate ? `&AdditionalDateEnd=${endDate}` : '') +
          (isDiscount != null ? `&IsDiscount=${isDiscount}` : '') +
          (isDirectDeliverer != null ? `&IsDirectDeliverer=${isDirectDeliverer}` : '') +
          (stopId ? `&StopId=${stopId}` : '') +
          (boardingId ? `&BoardingId=${boardingId}` : '') +
          (linkedPaymentOrder != null ? `&LinkedPaymentOrder=${linkedPaymentOrder}` : '') +
          (nfeNumber ? `&nroNfe=${nfeNumber}` : '') +
          (senderId ? `&SenderId=${senderId}` : '') +
          (isLink != null ? `&IsLink=${isLink}` : '') +
          (applicationUserId ? `&ApplicationUserId=${applicationUserId}` : ''),

        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createAditionals(_, body) {
    const additionalDtos = body.additionalDtos.map((aditional) => {
      const {
        boardingId,
        stopId,
        observation,
        price,
        additionalDate,
        isDiscount,
        isLink,
        nfeNumber: accessNfe,
        senderId
      } = aditional;
      const justificationId = aditional.justification.id;
      return {
        boardingId,
        additionalDate,
        isDiscount,
        justificationId,
        stopId,
        observation,
        price,
        isLink,
        accessNfe,
        senderId
      };
    });
    const aditionalToCreate = { ...body, additionalDtos };
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createAditionals,
        requestOptionsPOST(localStorage.getItem('accessToken'), aditionalToCreate)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteAditional(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteAditional + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editAditional(_, body) {
    const {
      id,
      applicationUserId,
      isDirectDeliverer,
      isDiscount,
      price,
      additionalDate,
      observation,
      boardingId,
      stopId,
      justificationId,
      isLink,
      senderId,
      nfeNumber: accessNfe
    } = body;

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.editAditional,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), {
          id,
          applicationUserId,
          isDirectDeliverer,
          isDiscount,
          price,
          additionalDate,
          observation,
          boardingId,
          stopId,
          justificationId,
          isLink,
          senderId,
          accessNfe
        })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async getRelatedAditionals(_, userId) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getRelatedAditionals + userId, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async exportAditionalSheet(_, params = { pageSize: 1000 }) {
    const obj = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken').toString(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Response-Type': 'APPLICATION/octet-stream'
      },
      method: 'POST'
    };

    const {
      pageSize,
      initialDate,
      endDate,
      isDiscount,
      isDirectDeliverer,
      stopId,
      boardingId,
      applicationUserId,
      linkedPaymentOrder,
      nfeNumber,
      senderId,
      isLink
    } = params;

    const URL =
      baseURL +
      Api.exportAditionalSheet +
      `?PageNumber=1&PageSize=${pageSize}` +
      (initialDate ? `&AdditionalDateStart=${initialDate}` : '') +
      (endDate ? `&AdditionalDateEnd=${endDate}` : '') +
      (isDiscount != null ? `&IsDiscount=${isDiscount}` : '') +
      (isDirectDeliverer != null ? `&IsDirectDeliverer=${isDirectDeliverer}` : '') +
      (stopId ? `&StopId=${stopId}` : '') +
      (boardingId ? `&BoardingId=${boardingId}` : '') +
      (linkedPaymentOrder != null ? `&LinkedPaymentOrder=${linkedPaymentOrder}` : '') +
      (nfeNumber ? `&nroNfe=${nfeNumber}` : '') +
      (senderId ? `&SenderId=${senderId}` : '') +
      (isLink != null ? `&IsLink=${isLink}` : '') +
      (applicationUserId ? `&ApplicationUserId=${applicationUserId}` : '');
    const nowDate = new Date();
    const fileName = `RELATORIO_DOS_ADICIONAIS_${nowDate.toLocaleDateString()}.xlsx`;

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (err) {
      console.log(err);
    }
  },

  async exportPaymentOrderSheet(_, params = { pageSize: 1000 }) {
    const obj = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('accessToken').toString(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Response-Type': 'APPLICATION/octet-stream'
      },
      method: 'POST'
    };

    const {
      pageSize,
      initialCreatedAt,
      endCreatedAt,
      initialForecast,
      endForecast,
      initialPayment,
      endPayment,
      statusId,
      typeId,
      transhipmentOrDelivererId,
      isDischarge,
      boardingNumbers
    } = params;

    let boardingNumbersParam = boardingNumbers.length
      ? boardingNumbers.reduce((acc, cur, i) => {
          const concatSign = boardingNumbers.length - 1 === i ? '' : '&';
          return (acc += `BoardingNumber=${cur}${concatSign}`);
        }, '')
      : [];

    const URL =
      baseURL +
      Api.exportPaymentOrders +
      `?PageSize=${pageSize}` +
      (initialCreatedAt ? `&CreatedAtStart=${initialCreatedAt}` : '') +
      (endCreatedAt ? `&CreatedAtEnd=${endCreatedAt}` : '') +
      (initialForecast ? `&PaymentForecastStart=${initialForecast}` : '') +
      (endForecast ? `&PaymentForecastEnd=${endForecast}` : '') +
      (initialPayment ? `&PaymentStart=${initialPayment}` : '') +
      (endPayment ? `&PaymentEnd=${endPayment}` : '') +
      (statusId ? `&StatusId=${statusId}` : '') +
      (typeId ? `&TypeId=${typeId.id}` : '') +
      (transhipmentOrDelivererId !== null ? `&DelivererId=${transhipmentOrDelivererId}` : '') +
      (boardingNumbers.length ? `&${boardingNumbersParam}` : '') +
      (isDischarge !== null ? `&IsDischarge=${isDischarge}` : '');
    const nowDate = new Date();
    const fileName = `RELATORIO_ORDENS_DE_PAGAMENTO_${nowDate.toLocaleDateString()}.xlsx`;

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (err) {
      console.log(err);
    }
  },

  getSenders() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSenders, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
